export const UPDATE_DAYS_COUNT =
  'app/EditSessionPage/TlfbConfig/UPDATE_DAYS_COUNT';
export const UPDATE_RANGE_SETTINGS =
  'app/EditSessionPage/TlfbConfig/UPDATE_RANGE_SETTINGS';
export const UPDATE_DATE_RANGE =
  'app/EditSessionPage/TlfbConfig/UPDATE_DATE_RANGE';
export const UPDATE_DISPLAY_HELPING_MATERIALS =
  'app/EditSessionPage/TlfbConfig/UPDATE_DISPLAY_HELPING_MATERIALS';
